(() => {
  if (customElements.get('sokids-header')) return;
  customElements.define('sokids-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const toggle = this.querySelector('.sk-mobile-toggle');
      const backdrop = this.querySelector('.sk-backdrop');
      const dropdowns = [...this.querySelectorAll('.sk-dropdown')];
      const searchToggle = this.querySelector('.sk-search-toggle');
      const searchForm = this.querySelector('.sk-inline-search');
      const nav = this.querySelector('.sk-nav');
      const sync = () => { backdrop.hidden = !this.hasAttribute('data-mobile-open') && !dropdowns.some(d => d.open); };
      const search = open => {
        this.toggleAttribute('data-search-open',open);
        searchForm.hidden = !open;
        nav.hidden = open;
        searchToggle.setAttribute('aria-expanded',String(open));
        searchToggle.setAttribute('aria-label',open ? 'Aramayı kapat' : 'Aramayı aç');
        if (open) {
          dropdowns.forEach(d => d.open = false);
          this.removeAttribute('data-mobile-open');
          toggle.setAttribute('aria-expanded','false');
          searchForm.querySelector('input').focus();
        }
        sync();
      };
      const close = () => { dropdowns.forEach(d => d.open = false); search(false); this.removeAttribute('data-mobile-open'); toggle.setAttribute('aria-expanded','false'); sync(); };
      toggle.addEventListener('click', () => {
        const open = !this.hasAttribute('data-mobile-open');
        close(); this.toggleAttribute('data-mobile-open',open); toggle.setAttribute('aria-expanded',String(open)); sync();
      },options);
      searchToggle.addEventListener('click', () => search(!this.hasAttribute('data-search-open')),options);
      dropdowns.forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) { dropdowns.forEach(other => { if (other !== details) other.open = false; }); search(false); }
          sync();
        },options);
        details.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          details.open = !details.open;
        },options);
        details.querySelector('summary').addEventListener('pointerenter' , event => {
          if (event.pointerType === 'mouse' && matchMedia('(min-width:990px)').matches) details.open = true;
        },options);
      });
      backdrop.addEventListener('click',close,options);
      document.addEventListener('click',event => { if (!this.contains(event.target)) close(); },options);
      this.addEventListener('keydown',event => {
        if (event.key !== 'Escape') return;
        const target = this.hasAttribute('data-search-open') ? searchToggle : this.hasAttribute('data-mobile-open') ? toggle : event.target.closest('details')?.querySelector('summary');
        close(); target?.focus();
      },options);

      let viewportWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        if (window.innerWidth === viewportWidth) return;
        viewportWidth = window.innerWidth;
        close();
      },options);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
})();
